import { Modal } from '@app/components/common/Modal/Modal';
import { Spinner } from '@app/components/common/Spinner/Spinner';
import { IFile } from '@app/interfaces/file';
import { ANY_OBJECT } from '@app/interfaces/interfaces';
import { Col, Row } from 'antd';
import React from 'react';
import { AddFileForm } from './AddFileForm/AddFileForm';

interface AddFileModalProps {
  file: IFile | null;
  isOpen: boolean;
  onOpenChange: () => void;
  loading: boolean;
  onFinish: (data: ANY_OBJECT) => void;
}

export const AddFileModal: React.FC<AddFileModalProps> = ({ loading, isOpen, onOpenChange, onFinish, file }) => {
  return (
    <Modal width={900} open={isOpen} onCancel={onOpenChange} footer={null} destroyOnClose>
      <Spinner spinning={loading}>
        <Row gutter={[15, 15]}>
          <Col span={24}>
            <AddFileForm loading={loading} onFinish={onFinish} file={file} />
          </Col>
        </Row>
      </Spinner>
    </Modal>
  );
};
